import React from 'react'
import { Box, Grid, makeStyles, Typography } from '@material-ui/core'
import { Section } from './Section'

const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: theme.palette.grey[500],
  },
}))

type Props = {
  title: string
  subtitle?: string
  children: React.ReactNode
  omitPadding?: boolean
}

export function SingleSettingSection({
  title,
  subtitle,
  children,
  omitPadding,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Section omitPadding={omitPadding}>
      <Grid container spacing={4}>
        <Grid item sm={6}>
          <Box mt={1.5}>
            <Typography variant="h5">{title}</Typography>
            <Box mt={1}>
              <Typography className={classes.subtitle}>{subtitle}</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item sm={6}>
          {children}
        </Grid>
      </Grid>
    </Section>
  )
}
